import {
  ConnectionPayload,
  Endpoint,
  SubscriptionPostPayload,
  SyncPayload,
} from "../../typings/types"

import { objToParams } from "./misc"

export const modifyConnectionUrl = ({ domain, direction }: ConnectionPayload) =>
  Endpoint.CONNECTION + `?domain=${domain}&direction=${direction}`

export const syncUrl = (params: SyncPayload) =>
  Endpoint.SYNC + "?" + objToParams(params)

export const confirmSubscriptionUrl = (params: SubscriptionPostPayload) =>
  Endpoint.SUBSCRIPTION + "?" + objToParams(params)
